import Skeleton from "react-loading-skeleton";
import { formatDiscount, formatPrice } from "../../../../utils/price.utils";

function PriceDetailsSection({ localLoading, currentPrice, selectedSize }) {
  const hasDiscount =
    selectedSize &&
    Number(selectedSize.discount) > 0 &&
    Number(selectedSize.mrp) > Number(currentPrice);

  return (
    <p className="price_details">
      {localLoading ? (
        <Skeleton width={120} />
      ) : (
        <>
          <strong>{formatPrice(currentPrice)}</strong>{" "}

          {hasDiscount && (
            <span className="sub-1">
              <del>{formatPrice(selectedSize.mrp)}</del>{" "}
              <span className="dis-sub">
                {formatDiscount(selectedSize.discount)}
              </span>{" "}
              <span className="tax-note">(inc. of all taxes)</span>
            </span>
          )}
        </>
      )}
    </p>
  );
}

export default PriceDetailsSection;
